// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CallerVm from "../../../view-model/CallerVm.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

function partnerTableSchema(workspaceDispatch) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Partner's Name"
            },
            accessor: (function (data) {
                return {
                        TAG: /* Text */0,
                        _0: data.name
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Primary Number"
              },
              accessor: (function (data) {
                  return {
                          TAG: /* Text */0,
                          _0: data.primary_number
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Secondary Number"
                },
                accessor: (function (data) {
                    return {
                            TAG: /* Text */0,
                            _0: Belt_Option.getWithDefault(data.secondary_number, "N/A")
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Owner's Number"
                  },
                  accessor: (function (data) {
                      return {
                              TAG: /* Text */0,
                              _0: data.owner_number
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: ""
                    },
                    accessor: (function (data) {
                        return {
                                TAG: /* Custom */5,
                                _0: (function (param) {
                                    return React.createElement(PrimaryButton$Catalyst.make, {
                                                buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                                      TAG: /* Text */0,
                                                      _0: "View Profile"
                                                    }, undefined, (function (_event) {
                                                        return Curry._2(workspaceDispatch.addTab, {
                                                                    TAG: /* DriverDashboardV2 */5,
                                                                    _0: data.msisdn
                                                                  }, false);
                                                      }), undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                                              });
                                  })
                              };
                      })
                  },
                  tl: /* [] */0
                }
              }
            }
          }
        };
}

function make(partners) {
  return List.map(CallerVm.PartnerVm.getVm, partners);
}

var TableRowGenerator = {
  make: make
};

function PartnerDetailsTable(Props) {
  var partners = Props.partners;
  var workspaceDispatch = Props.workspaceDispatch;
  return React.createElement("div", {
              className: "c-search-result caller-table"
            }, React.createElement("h2", undefined, "Partner"), React.createElement(TableComponent$Catalyst.make, {
                  columns: partnerTableSchema(workspaceDispatch),
                  rowData: List.map(CallerVm.PartnerVm.getVm, partners)
                }));
}

var make$1 = PartnerDetailsTable;

export {
  partnerTableSchema ,
  TableRowGenerator ,
  make$1 as make,
  
}
/* react Not a pure module */
